import { useSelector } from 'react-redux';

import { selectHasFiber, selectIsPreinstall } from '@app/redux';

export const useHasFiberPreinstall = (): boolean => {
  const hasPreinstall = useSelector(selectIsPreinstall);
  const hasFiberInternet: boolean = useSelector(selectHasFiber);

  const hasFiberPreinstall = hasFiberInternet && hasPreinstall;

  return hasFiberPreinstall;
};
